'use strict';

var renderTemplate = require('./renderTemplate');

function reloadOptions($select, savedValuesOfSelectedOption) {
  if (!$select) return;

  var apiUrl = $select.data('apiUrl');
  var $prev = $select.prevAll('select').first();
  var requestParams = {};

  while ($prev.length) {
    $.each($prev.find('option:selected').data(), function (name, value) {
      requestParams[name] = value;
    });
    $prev = $prev.prevAll('select').first();
  }

  $select.find('option:first-of-type').nextAll('option').remove();

  $.ajax(apiUrl, {
    data: requestParams,
    dataType: 'json',
    success: function (data) {
      if (data.status === 'success' || data.status === 'maintenance') {
        $.each(data.result, function (i, item) {
          var $option = $('<option>' + item.title + '</option>');

          // Если у нас есть сохраненные данные и значение с сервера совпадает с нашим (первым в массиве),
          // то делаем его "выбранным"
          if (savedValuesOfSelectedOption && item.title === savedValuesOfSelectedOption[0]) {
            $option.prop('selected', true);
          }

          $.each(item.params, function (name, value) {
            $option.data(name, value);
          });

          $select.append($option);
        });

        $select.prop('disabled', false);


        // Если у нас есть еще сохраненные значения, то отправляем их
        // или триггерим событие в ином случае, чтобы если все селекты выбраны,
        // разблокировать кнопку
        if (savedValuesOfSelectedOption) {
          savedValuesOfSelectedOption.splice(0, 1); // Мутируем массив, после работы с ним (удаляем первый элемент)

          if (savedValuesOfSelectedOption.length) {
            reloadOptions($select.nextAll('select').first(), savedValuesOfSelectedOption);
          } else {
            $select.trigger('change');
            enabledForm($select.closest('form')[0]);
          }
        }
      } else {
        renderErrorMessage($select);
      }
    },
    error: function () {
      renderErrorMessage($select);
    }
  });
}

function renderErrorMessage($select) {
  $select.parent().parent().before($('<div class="alert alert-danger">Сервис временно недоступен.</div>'));
}

module.exports = function () {
  $('[js-report]').each(function () {
    var form = this;
    var $form = $(form);
    var apiUrl = $form.data('apiUrl');

    // Получаем сохраненные данные и отправляем аргументом для рендера (значений может не быть)
    var savedValuesOfSelectedOption = JSON.parse(sessionStorage.getItem(apiUrl));

    if (savedValuesOfSelectedOption) {
      disabledForm(form);
    }

    reloadOptions($form.find('select:first-of-type'), savedValuesOfSelectedOption);

    $form.on('change', 'select', function () {
      var $select = $(this);
      var $btnSubmit = $form.find('button[type="submit"]');

      if ($select.find('option:selected').index() > 0) {
        reloadOptions($select.nextAll('select').first());
      }

      $select.nextAll('select').each(function () {
        $(this).find('option:first-of-type').nextAll().remove();
        $(this).prop('disabled', true);
      });

      if ($select.is('[js-report] select:last-of-type') && $select.find('option:selected').index() > 0) {
        $btnSubmit.prop('disabled', false);
      } else {
        $btnSubmit.prop('disabled', true);
      }

      saveValuesOfSelectedOptions(form, apiUrl);
    });

    $form.on('submit', function (event) {
      event.preventDefault();

      var $this = $(this);
      var templateName = $this.data('templateName');
      var requestParams = {};
      var $templateContainer = $('[handlebars-template-container]');

      $this.find('select').each(function () {
        $.each($(this).find('option:selected').data(), function (name, value) {
          requestParams[name] = value;
        });
      });

      $this.find('input[type=checkbox]:checked').each(function () {
        requestParams[this.getAttribute('name')] = true;
      });

      $.ajax(apiUrl, {
        data: requestParams,
        dataType: 'json',
        success: function (data) {
          window.history.pushState({
            apiUrl: apiUrl,
            templateName: templateName,
            requestParams: requestParams
          }, null, ($form.attr('action') + '?' + decodeURIComponent($.param(requestParams))).replace(/\?$/, ''));

          renderTemplate($templateContainer, data, templateName);
          $templateContainer.data('apiUrl', apiUrl);
          $templateContainer.data('templateName', templateName);
        },
        error: function (data) {
          renderTemplate($templateContainer, data.responseJSON);
        }
      });
    });
  });
};

function saveValuesOfSelectedOptions(container, keyName) {
  // Сохраняем в sessionStorage выбранные options (только содержание),
  // чтобы при перезагрузки или переходе назад, восстанавливать значения
  var selectedOptions = container.querySelectorAll('option:checked');
  var selectedOptionsText = [];

  [].slice.call(selectedOptions).every(function (selectedOption) {
    var $prevOption = $(selectedOption).prev();

    // Если предыдущего элемента нет, значит это первый дефолтный option и мы выходим из цикла
    if ($prevOption.length !== 0) {
      selectedOptionsText.push(selectedOption.textContent);
      return true;
    }
  });

  // Ключ - уникальная ссылка формы (data-api-url)
  sessionStorage.setItem(keyName, JSON.stringify(selectedOptionsText));
}

function disabledForm(form) {
  if (!form) return;
  form.classList.add('loading');
}

function enabledForm(form) {
  if (!form) return;
  form.classList.remove('loading');
}